import React from 'react';
import { Facebook, Linkedin, Twitter, Instagram, Send, MessageCircle } from 'lucide-react';
import { useI18n } from '@/i18n/index.jsx';

const SITE_URL = 'https://tudoconversor.com.br/';

function ShareButtons({ variant = 'light', className = '' }) {
  const { lang } = useI18n();
  const isEN = lang === 'en';

  const text = isEN
    ? 'TudoConversor - free and accurate online unit converter'
    : 'TudoConversor - conversor de unidades online, gratuito e preciso';

  const encodedUrl = encodeURIComponent(SITE_URL);
  const encodedText = encodeURIComponent(text);

  const links = [
    { name: 'Facebook', Icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}` },
    { name: 'X (Twitter)', Icon: Twitter, href: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}` },
    { name: 'LinkedIn', Icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}` },
    { name: 'WhatsApp', Icon: MessageCircle, href: `https://api.whatsapp.com/send?text=${encodedText}%20${encodedUrl}` },
    { name: 'Telegram', Icon: Send, href: `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}` },
    { name: 'Instagram', Icon: Instagram, href: 'https://www.instagram.com/' }
  ];

  const isDark = variant === 'dark';

  return (
    <div className={`flex flex-col items-center gap-3 sm:flex-row sm:items-center sm:gap-4 ${className}`}>
      <p
        className={`m-0 text-sm font-medium ${isDark ? 'text-primary-foreground/80' : 'text-muted-foreground'}`}
      >
        {isEN ? 'Share TudoConversor:' : 'Compartilhe o TudoConversor:'}
      </p>
      <ul className="flex flex-wrap items-center justify-center gap-2">
        {links.map(({ name, Icon, href }) => (
          <li key={name}>
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={isEN ? `Share on ${name}` : `Compartilhar no ${name}`}
              title={isEN ? `Share on ${name}` : `Compartilhar no ${name}`}
              className={`inline-flex h-11 w-11 items-center justify-center rounded-lg border transition-colors active:scale-[0.98] ${
                isDark
                  ? 'border-white/20 text-primary-foreground/90 hover:bg-white/10 hover:text-white'
                  : 'border-border/60 bg-muted/30 text-muted-foreground hover:border-primary/40 hover:bg-primary/5 hover:text-primary'
              }`}
            >
              <Icon className="h-5 w-5" strokeWidth={1.75} aria-hidden="true" />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ShareButtons;
